import request from '@/utils/request';

// 新增活动配置
export function addActivityConfig(values) {
  return request('/activityReport/addActivityTrackingConfig', {
    method: 'POST',
    data: values,
  });
}

// 更新活动配置
export function updateActivityConfig(values) {
  return request('/activityReport/updateActivityTrackingConfig', {
    method: 'POST',
    data: values,
  });
}

// 删除活动配置
export function deleteActivityConfig(values) {
  return request('/activityReport/deleteActivityTrackingConfig', {
    method: 'POST',
    data: values,
  });
}

// 查询活动配置
export function queryActivityConfig(values) {
  return request('/activityReport/queryActivityTrackingConfigDetail', {
    method: 'POST',
    data: values,
  });
}
